import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash'

import { loadCustomers } from '../../store/Customer/actions'
import { loadPreOrders } from '../../store/Order/actions'
import { loadCustomerOrderingPreferences } from '../../store/CustomerOrderingPreference/actions'
import { loadCustomerPayments } from '../../store/CustomerPayment/actions'
import { loadRevenueCenters } from '../../store/RevenueCenter/actions'
import { makeGetSuitesByCustomer } from '../../store/Suite/selector'

import { makeGetCustomerPayments } from '../../store/CustomerPayment/selector'

import SuitesCustomerDetails from '../../components/Customer/Details'
import { makeGetCustomer } from '../../store/Customer/selector'
import { getCurrentVenueUuid } from '../../store/Venues/selector'

const mapStateToProps = (state, ownProps) => {
  const customerId = get(ownProps, 'match.params.id')

  const getCustomerPayments = makeGetCustomerPayments()
  const customerPayments = getCustomerPayments(state, customerId)

  const getCustomer = makeGetCustomer()
  const getSuitesByCustomer = makeGetSuitesByCustomer()

  const customer = getCustomer(state, customerId)
  const suitesByCustomer = getSuitesByCustomer(state, customerId)

  const currentVenueUuid = getCurrentVenueUuid(state)

  return {
    customerId,
    customer,
    customerPayments,
    suitesByCustomer,
    currentVenueUuid,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const goBack = get(ownProps, 'history.goBack', () => {})
  const customerId = get(ownProps, 'match.params.id', '')
  const salesEventId = get(ownProps, 'match.params.eventId', '')

  return {
    loadCustomers: (currentVenueUuid) => {
      dispatch(loadCustomers(currentVenueUuid))
    },
    loadCustomerOrderingPreferences: (currentVenueUuid) => {
      dispatch(loadCustomerOrderingPreferences(customerId, currentVenueUuid))
    },
    loadCustomerPayments: () => {
      dispatch(loadCustomerPayments(customerId))
    },
    loadPreOrders: (currentVenueUuid) => {
      dispatch(loadPreOrders(currentVenueUuid, salesEventId))
    },
    loadRevenueCenters: (venueUuid) => {
      dispatch(loadRevenueCenters(venueUuid))
    },
    onClose: () => {
      goBack()
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SuitesCustomerDetails))
